var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 44.5H19.5C18.837 44.5 18.2011 44.2366 17.7322 43.7678C17.2634 43.2989 17 42.663 17 42V24.5C17 23.837 17.2634 23.2011 17.7322 22.7322C18.2011 22.2634 18.837 22 19.5 22H24.5L27 18.25H37L39.5 22H44.5C45.163 22 45.7989 22.2634 46.2678 22.7322C46.7366 23.2011 47 23.837 47 24.5V42C47 42.663 46.7366 43.2989 46.2678 43.7678C45.7989 44.2366 45.163 44.5 44.5 44.5Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 38.25C35.1066 38.25 37.625 35.7316 37.625 32.625C37.625 29.5184 35.1066 27 32 27C28.8934 27 26.375 29.5184 26.375 32.625C26.375 35.7316 28.8934 38.25 32 38.25Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.a76c58783a7bbf6ccae117bd5d7f8cce.svg";
export { ForwardRef as ReactComponent };